import { slice } from './slice';

export const { load, putAll, refresh, add, remove } = slice.actions;
